// extracted by mini-css-extract-plugin
export var content = "IntroRehomingListings-module--content--8b38c";
export var introcolumninner = "IntroRehomingListings-module--introcolumninner--e25b6";
export var introcolumnouter = "IntroRehomingListings-module--introcolumnouter--af2e3";
export var text = "IntroRehomingListings-module--text--443f6";
export var title = "IntroRehomingListings-module--title--d095a";